import type {MediaDevicePreferences} from '../platform/WebRtcPlatform';

const STORAGE_KEY = 'phonehq:group-call:devices';

const readString = (value: unknown): string | undefined =>
    typeof value === 'string' && value.length > 0 && value.length <= 512 ? value : undefined;

export const loadDevicePreferences = (): MediaDevicePreferences => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return {};
        }
        const parsed: unknown = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') {
            return {};
        }
        const record = parsed as Record<string, unknown>;
        return {
            audioInputId: readString(record.audioInputId),
            videoInputId: readString(record.videoInputId),
            audioOutputId: readString(record.audioOutputId),
        };
    } catch {
        return {};
    }
};

export const saveDevicePreferences = (preferences: MediaDevicePreferences): void => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
    } catch {
        return;
    }
};

export const deviceKindKey = (kind: MediaDeviceKind): keyof MediaDevicePreferences => {
    switch (kind) {
        case 'audioinput':
            return 'audioInputId';
        case 'videoinput':
            return 'videoInputId';
        default:
            return 'audioOutputId';
    }
};
